"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseShell = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const web_blizzard_reporting_1 = require("@snapchat/web-blizzard-reporting");
const web_experiments_1 = require("@snapchat/web-experiments");
const web_i18n_1 = require("@snapchat/web-i18n");
const web_sc_cookies_1 = require("@snapchat/web-sc-cookies");
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const pageContext_1 = require("./pageContext");
const webConfigContext_1 = require("./webConfigContext");
const media_query_1 = require("../../media-query");
const web_graphene_reporting_1 = require("@snapchat/web-graphene-reporting");
const web_sentry_1 = require("@snapchat/web-sentry");
const web_popup_1 = require("@snapchat/web-popup");
const web_blizzard_reporting_hooks_1 = require("@snapchat/web-blizzard-reporting-hooks");
const web_env_1 = require("@snapchat/web-env");
const index_1 = require("../../index");
/**
 * Base page wrapper
 * Should be rendered once in your SPA
 * Handles:
 * - Blizzard initialisation
 * - - Initial Web Page Open
 * - AB initialisation
 * - Sentry initialisation
 * - Graphene initialisation
 */
function BaseShell(props) {
    (0, web_sc_cookies_1.useSCWebSession)();
    const { locale, messages, country, webClientId = "", onGrafanaMetricsReady, shareId, webConfigNamespaces, sentryOrigin, sentryDsnUri, traceId, grapheneMetricsPrefix, appName = web_blizzard_reporting_1.PageType[props.pageType], } = props;
    (0, react_1.useMemo)(() => {
        if ((0, web_env_1.isRunningOnServer)())
            return;
        // initialise libraries on the first render
        void (0, web_experiments_1.initConfigsClient)();
        void (0, web_graphene_reporting_1.initMetrics)(onGrafanaMetricsReady);
        if (sentryOrigin && sentryDsnUri) {
            void (0, web_sentry_1.initSentry)(sentryOrigin, sentryDsnUri);
        }
    }, [onGrafanaMetricsReady, sentryOrigin, sentryDsnUri]);
    const isMobile = (0, media_query_1.useMobileMediaQuery)();
    const pageType = props.pageType;
    (0, react_1.useEffect)(() => {
        (0, web_blizzard_reporting_hooks_1.initBlizzardWebClient)({
            isProd: (0, web_env_1.isProd)(),
            withWebPageOpen: true,
            isGDPRCountry: props.isGDPRCountry,
            metricsAppId: appName,
        });
    }, [appName, props.isGDPRCountry]);
    // it's important to ensure Blizzard client is initiated before we call this
    (0, web_blizzard_reporting_hooks_1.useWebPageOpen)({ pageId: web_blizzard_reporting_1.PageType[pageType].toUpperCase() });
    const pageContextProps = (0, react_1.useMemo)(() => ({ isMobile, locale, pageType, webClientId, country, shareId, traceId }), [isMobile, locale, pageType, webClientId, country, shareId, traceId]);
    return ((0, jsx_runtime_1.jsx)(react_intl_1.IntlProvider, { locale: locale, defaultLocale: web_i18n_1.DEFAULT_LOCALE, messages: messages, children: (0, jsx_runtime_1.jsx)(index_1.ErrorBoundary, { locale: locale, messages: messages, pageType: pageType, webClientId: webClientId, webPageViewTraceId: traceId, metricsPrefix: grapheneMetricsPrefix, children: (0, jsx_runtime_1.jsx)(web_popup_1.PopupProvider, { children: (0, jsx_runtime_1.jsx)(webConfigContext_1.webConfigContext.Provider, { experimentNamespaces: webConfigNamespaces, webClientId: webClientId, countryCode: country, children: (0, jsx_runtime_1.jsx)(pageContext_1.PageContextProvider, { value: pageContextProps, children: props.children }) }) }) }) }));
}
exports.BaseShell = BaseShell;
//# sourceMappingURL=BaseShell.js.map